import { MainLayout } from './MainLayout';
import { Outlet } from 'react-router-dom';

export function ChampionshipLayout() {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
}
